import { pageState } from 'Pages/MessageCheckupLinkCheck/recoil/state/page'
import { logAppError } from 'Helpers/logger'
import getIntl from 'Helpers/intl'
import {
  checkupImageCheck,
  checkupLinkCheck,
  getMessageDetails,
  getMessageLinks,
  isSendingMessage
} from '../actions/actions'
import { messageLink, messageState } from '../state/message'
import { notifyParent } from 'Helpers/notifyParent'
import { MESSAGE_STR_TYPE_CONTENTSCAMPAIGN } from 'Constants/'
import { modalNoEdit, modalSendingState } from '../state/modals'

export const initCallback = ({ set }) => async id => {
  set(pageState, prev => ({ ...prev, loading: true }))

  try {
    const { subject, isBee, messageType, idCampaign } = await getMessageDetails(
      id
    )
    const { customParams, links } = await getMessageLinks(id)

    set(messageState, prev => ({
      ...prev,
      id,
      isBee,
      links: {
        link: links.filter(l => l.KindOfHtmlTag === 'link'),
        image: links.filter(l => l.KindOfHtmlTag === 'image')
      },
      messageType,
      customParams
    }))

    set(pageState, prev => ({
      ...prev,
      title: subject,
      messageType,
      isBee,
      id,
      idCampaign,
      loaded: true
    }))
  } catch (error) {
    logAppError({
      appError: error
    })
    set(pageState, prev => ({
      ...prev,
      error: getIntl().formatMessage({ id: 'Load.Alerts.ErrorGeneric' }),
      severity: 'danger'
    }))
  }

  set(pageState, prev => ({ ...prev, loading: false }))
}

export const checkLinkCallback = ({ set, snapshot }) => async (
  linkType,
  url
) => {
  set(pageState, prev => ({ ...prev, loading: true }))
  const { links, customParams } = await snapshot.getPromise(messageState)
  const urlIndex = links[linkType].findIndex(im => im.Url === url)
  set(messageLink(url), prev => ({
    ...prev,
    link: { ...links[linkType][urlIndex] },
    loading: true,
    loaded: false
  }))

  try {
    const checkUrl = new URL(url)
    if (customParams !== '' && linkType === 'link') {
      checkUrl.search =
        checkUrl.search === ''
          ? customParams
          : `${checkUrl.search}&${customParams}`
    }

    const { reachability, action, issues } = await (linkType === 'image'
      ? checkupImageCheck(checkUrl.href)
      : checkupLinkCheck(checkUrl.href))

    set(messageLink(url), prev => ({
      ...prev,
      reachability,
      action,
      issues: issues === undefined ? [] : issues
    }))
  } catch (error) {
    logAppError({
      appError: error
    })
    set(messageLink(url), prev => ({
      ...prev,
      error: true,
      errorMessage: 'err'
    }))
  }

  set(messageLink(url), prev => ({
    ...prev,
    loading: false,
    loaded: true
  }))
  set(pageState, prev => ({ ...prev, loading: false }))
}

export const editCallback = ({ set, snapshot }) => async ({ onRedirect }) => {
  set(pageState, prev => ({ ...prev, loading: true }))

  const { id, isBee, messageType, idCampaign } = await snapshot.getPromise(
    messageState
  )

  try {
    const isSending = await isSendingMessage(id)

    set(modalSendingState, prev => ({ ...prev, show: isSending }))

    if (!isSending) {
      if (isBee && messageType === MESSAGE_STR_TYPE_CONTENTSCAMPAIGN) {
        notifyParent('redirectMainFrame', [
          `App.aspx#/beePluginEditor/editCMP/${idCampaign}`
        ])
      }
      if (isBee && messageType !== MESSAGE_STR_TYPE_CONTENTSCAMPAIGN) {
        onRedirect(`/messages/email/bee/edit/${id}`)
      }
      if (!isBee) {
        notifyParent('redirectMainFrame', [
          `form_upd_newsletter.aspx?source=listemail&idNL=${id}`
        ])
      }
    } else {
      set(pageState, prev => ({
        ...prev,
        inlineMessage: getIntl().formatMessage({
          id: 'Load.EmailMessageList.MessageIsOnSentWarning'
        }),
        inlineMessageSeverity: 'warning'
      }))
      set(modalNoEdit, prev => ({
        ...prev,
        default: true
      }))
    }
  } catch (error) {
    logAppError({
      appError: error
    })
    set(pageState, prev => ({
      ...prev,
      error: getIntl().formatMessage({ id: 'Load.Alerts.ErrorGeneric' }),
      severity: 'danger'
    }))
  }

  set(pageState, prev => ({ ...prev, loading: false }))
}
